import { render, staticRenderFns } from "./warnStore.vue?vue&type=template&id=00d5cc51&scoped=true"
import script from "./warnStore.vue?vue&type=script&lang=js"
export * from "./warnStore.vue?vue&type=script&lang=js"
import style0 from "./warnStore.vue?vue&type=style&index=0&id=00d5cc51&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d5cc51",
  null
  
)

export default component.exports